export const constants = {
  CHANGE_PASSWORD_ENDPOINT: '/api/sign-in-service/v1/sign-in.challenge.respond',
  PASSWORD_UPDATE_STATUS: 'PASSWORD_CHANGED',
  PASSWORD_UPDATE_STATUS1: 'PASSWORD_NOT_CHANGED',
  PASSWORD_STATUS_AT: 'ABOUT_TO_EXPIRE',
  PASSWORD_EXPIRATION_AT: '2019-12-17T19:53:45.358Z',
  PASSWORD_RECOVERYURL_MOCK: 'https://bit.ly/0f6b0cc7',
};
